// eslint-disable-next-line @typescript-eslint/no-invalid-this
const global = globalThis || this || self

export { global }
export default global
